export default "__VITE_ASSET__54ec12f0__"